import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { solutions } from "@/data/site";
import { Eyebrow, Reveal, fadeUp, staggerContainer } from "../site/motion";

const MotionLink = motion.create ? motion.create(Link) : motion(Link);

const solutionSlugs = ["saas", "startups", "business-automation", "ai-integration", "system-modernization", "cloud-modernization"];

export default function Solutions() {
  return (
    <section id="solutions" data-testid="solutions-section" className="bg-[#F8FAFC] py-24 md:py-32">
      <div className="mx-auto w-full max-w-[1200px] px-6 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <Reveal className="max-w-xl">
            <Eyebrow>Solutions</Eyebrow>
            <h2 className="mt-5 text-3xl font-bold leading-[1.08] tracking-[-0.02em] text-slate-900 md:text-[2.6rem]">
              Start with the problem. We&rsquo;ll help shape the technology.
            </h2>
          </Reveal>
          <Reveal delay={1} className="max-w-md">
            <p className="text-sm leading-relaxed text-slate-600 md:text-base">
              Whether you&rsquo;re launching something new or improving an existing system,
              Bytevora can help turn business requirements into practical technology solutions.
            </p>
          </Reveal>
        </div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-14 grid gap-4 md:grid-cols-2"
        >
          {solutions.map((s, i) => (
            <MotionLink
              key={s.title}
              to={`/solutions#${solutionSlugs[i]}`}
              variants={fadeUp}
              data-testid={`solution-card-${i}`}
              className="group relative flex items-start gap-5 rounded-2xl border border-slate-200 bg-white p-6 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-0.5 hover:border-violet-600/35 hover:shadow-[0_24px_50px_-30px_rgba(124,58,237,0.35)] md:p-7"
            >
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl border border-slate-200 bg-slate-50 text-slate-600 transition-colors duration-300 group-hover:border-violet-600/25 group-hover:text-violet-600">
                <s.icon size={19} strokeWidth={1.7} />
              </span>
              <span>
                <h3 className="pr-8 text-[17px] font-semibold tracking-tight text-slate-900">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.desc}</p>
              </span>
              <ArrowUpRight
                size={17}
                className="absolute right-6 top-6 text-slate-300 transition-[color,transform] duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-violet-600"
              />
            </MotionLink>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
